import { Box } from "@mui/material";
import type { CSSProperties } from "react";
import { SITE_TYPE, SITE_VAR } from "src/domains/shared/constants/styles/site";
import { revealRef } from "./motion/reveal";
import { RevealWords } from "./RevealWords";
import { SiteText } from "./SiteText";

/** 홈은 구역 머리말 글자를 한 단계 크게 쓴다(팀 피드백) — 눈썹 17→19, 제목 46→52, 설명 18→20 (1440 기준) */
const LANDING_SIZES = {
  eyebrow: { fontSize: "19px" },
  title: { fontSize: "clamp(30px,3.7vw,52px)" },
  lead: { fontSize: "clamp(17px,1.4vw,20px)" },
} as const;

export interface SectionHeadProps {
  /** 제목 `h2` 의 id — 구역이 `aria-labelledby` 로 가리킨다 */
  titleId: string;
  eyebrow: string;
  /** 줄바꿈 태그(`<br/>` 등)가 든 번역 문구 */
  title: string;
  lead?: string;
  center?: boolean;
  /** 홈 구역 머리말(글자 한 단계 크게) */
  landing?: boolean;
}

/** 구역 머리말(시안 `.sec-head`): 작은 머리말 → 단어별로 떠오르는 큰 제목 → 설명. */
export function SectionHead({
  titleId,
  eyebrow,
  title,
  lead,
  center = false,
  landing = false,
}: SectionHeadProps) {
  return (
    <Box
      component="header"
      sx={{
        marginBottom: SITE_VAR.head,
        ...(center
          ? { textAlign: "center", "& [data-lead]": { marginInline: "auto" } }
          : {}),
      }}
    >
      <Box
        component="p"
        ref={revealRef}
        data-reveal="up"
        sx={{ ...SITE_TYPE.eyebrow, ...(landing ? LANDING_SIZES.eyebrow : {}) }}
      >
        {eyebrow}
      </Box>
      <Box
        component="h2"
        id={titleId}
        ref={revealRef}
        data-reveal="words"
        sx={{ ...SITE_TYPE.h2, ...(landing ? LANDING_SIZES.title : {}) }}
      >
        <RevealWords text={title} />
      </Box>
      {lead ? (
        <Box
          component="p"
          data-lead=""
          ref={revealRef}
          data-reveal="up"
          style={{ "--i": 2 } as CSSProperties}
          sx={{
            ...SITE_TYPE.lead,
            marginTop: "28px",
            ...(landing ? LANDING_SIZES.lead : {}),
          }}
        >
          <SiteText text={lead} />
        </Box>
      ) : null}
    </Box>
  );
}
